import { render, staticRenderFns } from "./OrderShipDetail.vue?vue&type=template&id=7a259db6&scoped=true&"
import script from "./OrderShipDetail.vue?vue&type=script&lang=js&"
export * from "./OrderShipDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderShipDetail.vue?vue&type=style&index=0&id=7a259db6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a259db6",
  null
  
)

export default component.exports